import styled from 'styled-components';
import { Button } from 'reactstrap';

const InlineButton = styled(Button)`
  line-height: 1;
`;

export default InlineButton;
